<template>
  <div class="row">
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.menus')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="company-details">
      <div ref="compDetailsContainer" :style="{height: windowHeight - pageTopHeight - navbarHeaderHeight - 1 + 'px'}">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
        <div class="card pad-bt-15" v-for="(location, index) in locations">
          <div class="card-content">
            <h5 class="pad-bt-15">
              <i class="ti-home"></i> {{$t('settingCompany.bussLoc')}}: {{location.name}}
            </h5>
            <template>
              <div class="row">
                <div v-if="location.dynamic_qr_code && location.dynamic_qr_code.length" class="col-md-8 mar-lt-5">
                    <display-qr
                    :location="location"
                  />
                </div>
                <div v-else class="col-md-8 mar-lt-5">
                  {{ $t('marketingFidelities.noData')}}
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="company-details">
          <div class="card pad-bt-15">
            <div class="row display-flex">
              <div class="card-content align-items-center mb-0 col-md-11 mar-lt-15 help-block warning">
                <span class="relative-top">{{ $t('settingCompany.generateQrMenu') }} <a href="#" @click.prevent="goToCompany()">{{ $t('settingCompany.generateQrMenuSettings') }}.</a></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import DisplayQr from 'src/components/UIComponents/Inputs/DisplayQr.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import 'sweetalert2/dist/sweetalert2.css'

  export default {
    components: {
      PSwitch,
      DisplayQr
      // GeneralTopBar
    },
    watch: {
    },
    data () {
      return {
        locations: [],
        windowHeight: 0,
        pageTopHeight: 76,
        navbarHeaderHeight: 0,
        loading: true
      }
    },
    updated: function () {
    },
    computed: {
    },
    created () {
      this.locations = this.getCompanyDetail('locations_details')
    },
    mounted () {
      this.$nextTick(() => {
        this.doHeightCalculation()
        this.loading = false

        window.addEventListener('resize', () => {
          this.doHeightCalculation()
        })
      })
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      doHeightCalculation () {
        this.windowHeight = window.innerHeight
        // this.navbarHeaderHeight = this.$refs.navbarHeader.clientHeight
      },
      scrollToPx (px) {
        // console.warn(px)
        var elem = this.$el
        // console.warn(elem.clientHeight)
        elem.scrollTop = elem.clientHeight
        window.scrollTo({
          left: 0,
          top: elem.clientHeight - px,
          behavior: 'smooth'
        })
      },
      goToCompany () {
        this.$session.set('selectedTab', this.$t('settingsPages.companyLocations'))
        this.$router.push('/settings')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/DynamicMenus/DynamicMenu.vue